import { Modal as ModalModule, UI, Utils } from 'common';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import InsuranceClaimFormModal from './InsuranceClaimFormModal.component';

const { Session, Navigation, Analytics, Util } = Utils;
const { openParcelGuardClaimForm } = Util;
const { Modal, ModalContext } = ModalModule;
const { WrappedButton, WrappedButtonType } = UI;
const globalPostUrl =
	'https://goglobalpost.custhelp.com/app/answers/detail/a_id/4276/';

const FileClaimModal = ({ modalId, data }) => {
	const { showModal, closeAll, showError } = useContext(ModalContext);
	const parcelGuard = data.print.insuranceType === 'parcelguard';

	return (
		<Modal
			modalId={modalId}
			className="history-claim-form file-claim-modal"
			header="File Claim"
			hideFooter
		>
			<div>
				<p>
					This print includes both Global Advantage Program Coverage and{' '}
					Stamps.com Insurance.
				</p>
				<p>
					<b>Step 1 - File Global Advantage Program Coverage Claim</b>
				</p>
				<WrappedButton
					buttonType={WrappedButtonType.Secondary}
					className="global-advantage-btn"
					onClick={() => {
						Analytics.trackEvent(
							'fileInsuranceClaim',
							{
								insurance_type: 'GlobalPost',
							},
							Analytics.agent.segment
						);
						Navigation.newTab(globalPostUrl);
					}}
					dataqa="file-claim-gap-coverage"
					label="Global Advantage Program Coverage Claim"
				/>

				<p>
					<b>
						Step 2 - File {parcelGuard ? 'ParcelGuard' : 'Stamps.com'} Claim
					</b>
				</p>
				<p>
					If you have any remaining losses to claim after accounting for Global
					Advantage Program Coverage, click{' '}
					<i>File {parcelGuard ? 'ParcelGuard' : 'Stamps.com'} Claim.</i>
				</p>
				<WrappedButton
					buttonType={WrappedButtonType.Secondary}
					onClick={() => {
						if (parcelGuard) {
							// Open ParcelGuard claim form in new tab
							openParcelGuardClaimForm(data.universalPostageId, showError);
						} else {
							// Show insurance claim form modal
							closeAll(() => {
								showModal({
									component: InsuranceClaimFormModal,
									data,
								});
							});
						}
					}}
					dataqa={`file-claim-${parcelGuard ? `ParcelGuard` : `Stamps.com`}`}
					label={`File ${parcelGuard ? `ParcelGuard` : `Stamps.com`} Claim`}
				/>
			</div>
		</Modal>
	);
};

FileClaimModal.propTypes = {
	data: PropTypes.shape({
		print: PropTypes.object,
	}),
};

export default FileClaimModal;
